// import "./ResumeProductInventoryDetail.scss";
import React, { useCallback, useEffect } from "react";
import { styled, Box } from "@mui/system";
import "./WalletDetails.scss";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import {
  getWalletsNameContains,
  rechargeWallet,
  getFeeInfo,
  getAllWalletInfo,
} from "../../../services/utilsWallet";
import DefaultImg from "../../../assets/market-icons/avatar-supervisor.jpg";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Modal from "@mui/material/Modal";
import { debounce } from "lodash";
import LinearProgress from "@mui/material/LinearProgress";
import Pagination from "@mui/material/Pagination";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

// status 0 = deactivated; anything else (incl. missing) counts as active
const isInactive = (wallet) => wallet?.status === 0;

const WALLETS_PER_PAGE = 10;

// wallet_type: 1 = customer wallet, 0 = trackable.
// customer_type values mirror backend parameter.py (CARETAKER=0, EMPLOYEE=1, CARETAKER_EMPLOYEE=2, EXTERNAL=4)
const CUSTOMER_TYPE_LABELS = {
  0: "Acudiente",
  1: "Empleado",
  2: "Empleado + Acudiente",
  4: "Externo",
};
const walletTypeLabel = (wallet) =>
  wallet.wallet_type === 1
    ? CUSTOMER_TYPE_LABELS[wallet.customer_type] || "Cliente"
    : "Estudiante";
const walletIdentifier = (wallet) =>
  wallet.wallet_type === 1 ? wallet.id_number : wallet.code;



const WalletDetails = (props) => {
  const {
    setSelectedWallet,
    selectedWallet,
    walletInfo,
    setWalletInfo,
    loading,
    // setLoading,
    recharge,
    setRechage,
  } = props;
  const [wallets, setWallets] = useState([]);
  const [, setInputText] = useState("");
  const [selectedOption, setSelectedOption] = useState("50000");
  const [selectedType, setSelectedType] = useState("cashier");
  const [quantity, setQuantity] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [, setOpen] = useState(false);
  const [supervisorProfile, ] = useState(
    () => JSON.parse(window.localStorage.getItem("profile"))
  )

  const [loadingCustomer, setLoadingCustomers] = useState(false);
  // const [loadingRecharge, setLoadingRecharge] = useState(false);
  const [loadingWalletInfo, setLoadingWalletInfo] = useState(false);


  // Modal states
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const [amount, setAmount] = useState(0);
  const [currentAmount, setCurrentAmount] = useState(0);

  //fee states
  const [feeAmount, setFeeAmount] = useState(null);
  const [feeData, setFeeData] = useState(null);


  
  const [isRechargeButtonEnabled, setIsRechargeButtonEnabled] = useState(false)


  const formatMoney = (number) => {
    if (typeof number !== "number" || isNaN(number)) {
      return "";
    }
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };
  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };
  const getNewQuantity = (walletQuantity) => {
    if (selectedOption === "otro") {
      if (quantity === "") {
        return parseInt(walletQuantity);
      } else {
        return parseInt(quantity) + parseInt(walletQuantity);
      }
    } else {
      return parseInt(walletQuantity) + parseInt(selectedOption);
    }
  };
  const getAmount = () => {
    if (selectedOption === "otro") {
      return parseInt(quantity);
    } else {
      return parseInt(selectedOption);
    }
  };

  // Open confirmation modal
  const handleOpenConfirmModal = () => {
    setIsRechargeButtonEnabled(true)
    const calculatedCurrentAmount = getNewQuantity(selectedWallet.wallet_type === 1 ? selectedWallet.wallet_balance / 100 : selectedWallet.current_balance / 100);//******************** */

    setCurrentAmount(calculatedCurrentAmount);
    setOpenConfirmModal(true);
  };

  // Close confirmation modal
  const handleCloseConfirmModal = () => {
    setOpenConfirmModal(false);
  };

  const BlueButton = styled(Button)(({ theme }) => ({
    backgroundColor: '#01A532',
    '&:hover': {
      backgroundColor: '#005d84',
    },
  }));




  const handleRecharge = (event) => {
    setIsRechargeButtonEnabled(false)
    let fkOrganization = localStorage.getItem("fk_organization");
    //TODO 
    let jsonBody = {
      wallet_type: selectedWallet.wallet_type,
      wallet_id: selectedWallet.id,
      email: selectedWallet.email,
      type: selectedType,
      fk_ontrack_organization: fkOrganization,
      amount: getAmount() * 100,
      description: `Top up amount: ${getAmount() * 100} method: ${selectedType.toUpperCase()}`,
      payin_info: {
        cashier: {
          fk_worker: supervisorProfile.profile.user.supervisor.id,
        },
      },
      payer: {
        name: selectedWallet.name,
        email: selectedWallet.email,
        phone: selectedWallet.mobile_phone,
        document: {
          documentId: selectedWallet.id_number,
          type: "CC",
        },
        billingAddress: {
          zipCode: "111111",
          state: "Cundinamarca",
          city: "Bogotá",
        },
      },
    };
    rechargeWallet(JSON.stringify(jsonBody)).then((data) => {

      handleCloseConfirmModal();
      setOpenModal(true);
      // window.location.reload();
    });
    // window.location.reload();
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };


  const [currentPage, setCurrentPage] = useState(1);
   
  const [numPages, setNumPages] = useState(1); 
  const [searchText, setSearchText] = useState('');
  const [showInactive, setShowInactive] = useState(false);


  const debouncedSearch = useCallback(
    debounce((text, includeInactive) => {
      setLoadingCustomers(true);
      let fkOrganization = localStorage.getItem("fk_organization");
      getWalletsNameContains(fkOrganization, text, 1, WALLETS_PER_PAGE, includeInactive).then((data) => {
        setWallets(data.wallets);
        setNumPages(data.pagination.num_pages);
        setLoadingCustomers(false);
      });
    }, 500),
    []
  );
  
  const handleTextChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    debouncedSearch(searchText, showInactive);
  }, [searchText, showInactive, debouncedSearch]);
  
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    setLoadingCustomers(true);
    let fkOrganization = localStorage.getItem("fk_organization");
    getWalletsNameContains(fkOrganization, searchText, value, WALLETS_PER_PAGE, showInactive).then((data) => {
      setWallets(data.wallets);
      setNumPages(data.pagination.num_pages);
      setLoadingCustomers(false);
    });
  };

  useEffect(() => {
  }, [feeAmount, amount]);

  useEffect(() => {
    const fetchFeeInfo = async () => {
      try {
        const fkOrganization = localStorage.getItem("fk_organization");
        const response = await getFeeInfo(fkOrganization);
        setFeeData(response);
      } catch (error) {
        console.error("Error al obtener la comisión:", error);
      }
    };

    fetchFeeInfo();
  }, []);

  useEffect(() => {
    const calculatedFeeAmount = () => {
      if (!feeData || !amount) return 0;

      if (feeData.fee_enabled === 1) {
        if (feeData.fee_type === 0) {
          return feeData.fee_amount / 100;
        } else if (feeData.fee_type === 1) {
          return (amount * feeData.fee_amount);
        }
      }
      return 0;
    };

    const feeAmount = calculatedFeeAmount();
    setFeeAmount(feeAmount);
  }, [amount, feeData]);

  useEffect(() => {
    setAmount(getAmount());
  }, [selectedOption, quantity]);

  // Fetch initial wallet info when selectedWallet changes
  useEffect(() => {
    const fetchWalletInfo = async () => {
      if (selectedWallet && selectedWallet.id) {
        setLoadingWalletInfo(true);
        try {
          const fkOrganization = localStorage.getItem("fk_organization");
          const data = await getAllWalletInfo(
            fkOrganization,
            1, // page_number
            10, // results_per_page
            selectedWallet.wallet_type,
            selectedWallet.id
          );
          
          // Set the complete wallet info including trackables
          setWalletInfo(data);
        } catch (error) {
          console.error("Error fetching wallet info:", error);
          setWalletInfo(null);
        } finally {
          setLoadingWalletInfo(false);
        }
      }
    };

    fetchWalletInfo();
  }, [selectedWallet, setWalletInfo]);


  const style = {
    position: "absolute",
    width: "100%",
    height: "100%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    display: "grid",
    placeItems: "center",
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="modal-box">
            <h2 className="modal-title">
              Se realizó la recarga exitosamente
            </h2>
            <div className="text-center modal-options">
              <Button >
                <a href="/billeteras">Continuar</a>
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      {selectedWallet ? (
        <div className="w-d-row-1">
          <div className="w-rowback">
            <ArrowBackIcon className="cursor-pointer"
              onClick={(e) => {
                setSelectedWallet(null);
                setInputText("");
                setRechage(false);
                // setWalletInfo(null);
                // setLoading(true);
              }}
            ></ArrowBackIcon>
            <li>Detalle de Billetera</li>
          </div>
          <div className="detail-wallet-info">
            <div className="detail-image-wallet">
              <img
                src={selectedWallet.image || DefaultImg}
                alt=""
                className="image-wallet-balance"
                onError={(e) => {
                  e.target.src = DefaultImg;
                }}
              />
            </div>
            <div>
              <li className="wallet-user-name">
                {selectedWallet.name ? selectedWallet.name : selectedWallet.first_name + ` ` + selectedWallet.last_name}
                {isInactive(selectedWallet) && <span className="wallet-status-badge">Inactiva</span>}
              </li>
              <li className="wallet-user-sub-title">{selectedWallet?.id_number ? `ID: ${selectedWallet.id_number}` : `ID: ${selectedWallet.code}`}</li>
            </div>


          </div>
          <div>
            {recharge ? (
              <>
                <div className="amount-recharge">
                  <li className="currect-amout-text">Saldo Actual:</li>
                  <li className="actual-wallet-quantity">
                    {selectedWallet.wallet_type === 1 ? (
                      <>{formatMoney(selectedWallet.wallet_balance / 100)}</>
                    ) : (
                      <>{formatMoney(selectedWallet.current_balance / 100)}</>
                    )}
                  </li>
                </div>
                <div className="pay-in-type-sect">
                  <li>Medio de pago</li>
                  <select
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                    className="type-topup-form-select"
                  >
                    {/* {[1, 2].includes(selectedWallet.wallet_type) && <option value="payroll_deduction">Descuento de nómina</option>} */}
                    <option value="cashier">Efectivo</option>
                    <option value="cashier_card">Tarjeta de credito</option>
                  </select>
                </div>
                <div className="pay-in-wallet-sect">
                  <li> Valor a Recargar</li>
                  <div className="row-wallet-recharge-options">
                    <label className="input-label-wallet-amount">
                      <input
                        type="radio"
                        value="50000"
                        checked={selectedOption === "50000"}
                        onChange={() => setSelectedOption("50000")}
                        className="input-radio-pi"
                      />
                      $50.000
                    </label>
                    <label className="input-label-wallet-amount">
                      <input
                        type="radio"
                        value="100000"
                        checked={selectedOption === "100000"}
                        onChange={() => setSelectedOption("100000")}
                        className="input-radio-pi"
                      />
                      $100.000
                    </label>
                    <label className="input-label-wallet-amount">
                      <input
                        type="radio"
                        value="200000"
                        checked={selectedOption === "200000"}
                        onChange={() => setSelectedOption("200000")}
                        className="input-radio-pi"
                      />
                      $200.000
                    </label>
                    <label className="input-label-wallet-amount">
                      <input
                        type="radio"
                        value="400000"
                        checked={selectedOption === "400000"}
                        onChange={() => setSelectedOption("400000")}
                        className="input-radio-pi"
                      />
                      $400.000
                    </label>
                    <div className="other-input-wallet">
                      <label className="input-label-wallet-amount">
                        <input
                          type="radio"
                          value="otro"
                          checked={selectedOption === "otro"}
                          onChange={() => setSelectedOption("otro")}
                          className="input-radio-pi"
                        />
                        Otro
                      </label>
                      <TextField
                        id="standard-basic"
                        variant="standard"
                        disabled={selectedOption !== "otro"}
                        onChange={handleQuantityChange}
                        style={{
                          fontFamily: "Catamaran-Light",
                          marginLeft: "10px" 
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="amount-recharge-commision">
                  <li className="new-quatity-fee">Valor de la comisión</li>
                  <li className="fee-quantity">
                    {feeAmount !== null ? formatMoney(feeAmount) : 0}
                  </li>
                </div>

                <div className="amount-recharge">
                  <li className="new-quatity-fee">Total a pagar</li>
                  <li className="fee-quantity">
                    {formatMoney(
                      (isNaN(amount) ? 0 : amount) + (isNaN(feeAmount) ? 0 : feeAmount)
                    )}
                  </li>
                </div>

                <div className="amount-recharge">
                  <li className="new-quatity-wallet">Nuevo Saldo:</li>
                  <li className="actual-wallet-quantity">
                    {selectedWallet.wallet_type === 1 ? (
                      // <>{selectedWallet.wallet_balance / 100}</>
                      <>
                        {formatMoney(
                          getNewQuantity(selectedWallet.wallet_balance / 100)
                        )}
                      </>
                    ) : (
                      <>
                        {formatMoney(
                          getNewQuantity(selectedWallet.current_balance / 100)
                        )}
                      </>
                    )}
                  </li>
                </div>
                <div className="button-recharge-cancel">
                  <Button
                    variant="contained"
                    size="medium"
                    style={{
                      fontSize: "12px",
                      backgroundColor: "#D24300",
                      fontFamily: "Catamaran-Light",
                    }}
                    className="cancel-button"
                    onClick={(e) => {
                      setRechage(false);
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant="contained"
                    size="medium"
                    style={{
                      fontSize: "12px",
                      backgroundcolor: "#01A532",
                      fontFamily: "Catamaran-Light",
                    }}
                    className="recharge-button"
                    onClick={handleOpenConfirmModal}
                  >
                    Confirmar Recarga
                  </Button>

                  {/* Confirmation modal */}
                  <Modal
                    open={openConfirmModal}
                    onClose={handleCloseConfirmModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <div className="modal-box-confirm-recharge">
                        <h2 className="modal-title-confirm">
                          Confirmar recarga
                        </h2>
                        <p className="modal-text-confirm">
                          ¿Confirma la recarga por {formatMoney(isNaN(amount) ? 0 : amount)} para {selectedWallet.name ? selectedWallet.name : selectedWallet.first_name + ` ` + selectedWallet.last_name}? El nuevo saldo será de {formatMoney(currentAmount)}
                        </p>
                        {/*<div className="modal-options-confirm">*/}
                          <p className="modal-text-confirm">
                            Resumen de la transacción:
                          </p>
                          {/* Resumen de la transacción */}
                          <div className="transaction-summary">
                            <div className="transaction-row">
                              <span className="transaction-label">Valor a recargar:</span>
                              <span className="transaction-value">{formatMoney(isNaN(amount) ? 0 : amount)}</span>
                            </div>
                            <div className="transaction-row">
                              <span className="transaction-label">Valor de la comisión:</span>
                              <span className="transaction-value">{formatMoney(isNaN(feeAmount) ? 0 : feeAmount)}</span>
                            </div>
                            <div className="transaction-row">
                              <span className="transaction-label">Total a pagar:</span>
                              <span className="transaction-value">{formatMoney(((isNaN(amount) ? 0 : amount) + (isNaN(feeAmount) ? 0 : feeAmount)))}</span>
                            </div>
                            <div className="transaction-row">
                              <span className="transaction-label">Nuevo saldo:</span>
                              <span className="transaction-value">{formatMoney(currentAmount)}</span>
                            </div>
                          </div>

                        <div className="modal-options-confirm-recharge">
                          <Button variant="text" color="primary" onClick={handleCloseConfirmModal}>
                            Cancelar recarga
                          </Button>

                          <BlueButton
                            variant="contained"
                            color="primary"
                            onClick={(event) => {
                              handleRecharge(event);
                            }}
                            disabled={!isRechargeButtonEnabled}
                            style={{ minWidth: '175.8px', maxHeight: '36.5px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                          >
                            {!isRechargeButtonEnabled ? (
                              <div className="spinner-container h-100 d-flex align-items-center">
                                <div className="spinner-border spinner-secondary" role="status" style={{ maxWidth: '24px', maxHeight: '24px'}}>
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            ) : (
                              <span>Confirmar recarga</span>
                            )}
                          </BlueButton>


                        </div>
                      </div>
                    </Box>
                  </Modal>

                </div>
              </>
            ) : (
              <>
                {!loading && (
                  <>
                    {selectedWallet.wallet_type === 1 ? (
                      <div>
                        <div className="detail-amount-info-wallet">
                          Saldo Disponible
                          <div className="amount-recharge">
                            <span className="amount-text">
                              {formatMoney(
                                walletInfo?.customer_wallet_info?.wallet_balance /
                                100
                              )}
                            </span>
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                fontSize: "10px",
                                backgroundColor: "#151E17",
                                fontFamily: "Muli-Regular",
                              }}
                              className="recharge-button"
                              onClick={(e) => {
                                setRechage(true);
                              }}
                            >
                              Recargar
                            </Button>
                          </div>
                        </div>
                        <div>
                          Estudiantes a cargo
                          {loadingWalletInfo ? (
                            <div className="loading-message">
                              <p>Cargando estudiantes...</p>
                            </div>
                          ) : walletInfo?.trackables_wallet_info && walletInfo.trackables_wallet_info.length > 0 ? (
                            walletInfo.trackables_wallet_info.map(
                              (trackable) => (
                                <div 
                                  key={trackable.code}
                                  className={`row-wallet-information${isInactive(trackable) ? " wallet-inactive" : ""}`}
                                  onClick={() => {
                                    trackable.wallet_type = 0
                                    setSelectedWallet(trackable)
                                  }}
                                >
                                  <div className="row-wallet-information-image">
                                    <img
                                      src={trackable.image || DefaultImg}
                                      alt=""
                                      className="image-wallet-balance"
                                      onError={(e) => {
                                        e.target.src = DefaultImg;
                                      }}
                                    />
                                  </div>
                                  <div className="row-wallet-information-text">
                                    <li className="li-name">
                                      {trackable.name}
                                      {isInactive(trackable) && <span className="wallet-status-badge">Inactiva</span>}
                                    </li>
                                    {/* <li className="li-rol">El rol</li> */}
                                    <div>
                                      <li className="li-balance">
                                        Disponible:
                                        {formatMoney(
                                          trackable.current_balance / 100
                                        )}
                                      </li>
                                    </div>
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                            <div className="no-trackables-message">
                              <p>No hay estudiantes a cargo</p>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="detail-amount-info-wallet">
                          Saldo Disponible
                          <div className="amount-recharge">
                            <span className="amount-text">
                              {formatMoney(
                                selectedWallet.current_balance / 100
                              )}
                            </span>
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                fontSize: "10px",
                                backgroundcolor: "#01A532",
                                fontFamily: "Muli-Regular",
                              }}
                              className="recharge-button"
                              onClick={() => {
                                setRechage(true);
                              }}
                            >
                              Recargar
                            </Button>
                          </div>
                        </div>
                        <div>
                          Acudientes asociados
                          {loadingWalletInfo ? (
                            <div className="loading-message">
                              <p>Cargando acudientes...</p>
                            </div>
                          ) : walletInfo?.customer_wallets_info && walletInfo.customer_wallets_info.length > 0 ? (
                            walletInfo.customer_wallets_info.map(
                              (customer) => (
                                <div 
                                  key={customer.id}
                                  className={`row-wallet-information${isInactive(customer) ? " wallet-inactive" : ""}`}
                                  onClick={() => {
                                    customer.wallet_type = 1
                                    setSelectedWallet(customer)
                                  }
                                }>
                                  <div className="row-wallet-information-image">
                                    <img
                                      src={customer.first_name || DefaultImg}
                                      alt=""
                                      className="image-wallet-balance"
                                      onError={(e) => {
                                        e.target.src = DefaultImg;
                                      }}
                                    />
                                  </div>
                                  <div className="row-wallet-information-text">
                                    <li className="li-name">
                                      {customer.first_name}
                                      {isInactive(customer) && <span className="wallet-status-badge">Inactiva</span>}
                                    </li>
                                    {/* <li className="li-rol">El rol</li> */}
                                    <div>
                                      <li className="li-balance">
                                        Disponible:
                                        {formatMoney(
                                          customer.wallet_balance / 100
                                        )}
                                      </li>
                                    </div>
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                            <div className="no-customers-message">
                              <p>No hay acudientes asociados</p>
                            </div>
                          )}
                        </div>
                        {/* <div>
                          <li className="person-in-charge">Persona a cargo</li>
                          <div className="row-wallet-information">
                            <div className="row-wallet-information-image">
                              <img
                                src={
                                  walletInfo.customer_wallet_info.image ||
                                  DefaultImg
                                }
                                alt=""
                                className="image-wallet-balance"
                                onError={(e) => {
                                  e.target.src = DefaultImg;
                                }}
                              />
                            </div>
                            <div className="row-wallet-information-text">
                              <li className="li-name">
                                {walletInfo.customer_wallet_info.first_name +
                                  " " +
                                  walletInfo.customer_wallet_info.last_name}
                              </li>
                              <div>
                                <li className="li-balance">
                                  Disponible:
                                  {formatMoney(
                                    walletInfo.customer_wallet_info
                                      .wallet_balance / 100
                                  )}{" "}
                                </li>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="w-d-row">
          Billeteras
          <div className="wallet-search-bar">
            <div>
              <SearchIcon></SearchIcon>
              <TextField
                id="standard-basic"
                variant="standard"
                onChange={handleTextChange}
              />
            </div>
            <FormControlLabel
              control={
                <Switch
                  checked={showInactive}
                  onChange={(e) => {
                    setShowInactive(e.target.checked);
                    setCurrentPage(1);
                  }}
                  size="small"
                />
              }
              label="Mostrar inactivas"
              className="wallet-inactive-toggle"
              sx={{ ml: "auto", mr: 0 }}
            />
          </div>
          <div className="wallet-list-detail">
            {loadingCustomer && <LinearProgress />}
            {wallets.length > 0 && (
              <div className="row-wallet-header">
                <div className="row-wallet-information-image row-wallet-header-spacer"></div>
                <div className="row-wallet-information-text">Nombre</div>
                <div className="row-wallet-col row-wallet-col-type">Tipo</div>
                <div className="row-wallet-col row-wallet-col-identifier">ID / Código</div>
                <div className="row-wallet-col row-wallet-col-email">Email</div>
                <div className="row-wallet-col row-wallet-col-balance">Saldo</div>
                <div className="row-wallet-information-refund"></div>
              </div>
            )}
            {wallets.map((wallet, index) => (
              <div key={wallet.id} className={`row-wallet-information cursor-pointer${isInactive(wallet) ? " wallet-inactive" : ""}`} onClick={() => {
                setSelectedWallet(wallet);
              }}>
                <div className="row-wallet-information-image">
                  <img
                    src={wallet.image || DefaultImg}
                    alt=""
                    className="image-wallet-balance"
                    onError={(e) => {
                      e.target.src = DefaultImg;
                    }}
                  />
                </div>
                <div className="row-wallet-information-text">
                  <li className="li-name">
                    {wallet.name}
                    {isInactive(wallet) && <span className="wallet-status-badge">Inactiva</span>}
                  </li>
                </div>
                <div className="row-wallet-col row-wallet-col-type">
                  <span className="wallet-type-badge">{walletTypeLabel(wallet)}</span>
                </div>
                <div className="row-wallet-col row-wallet-col-identifier">
                  {walletIdentifier(wallet) || "—"}
                </div>
                <div
                  className="row-wallet-col row-wallet-col-email"
                  title={wallet.wallet_type === 1 ? wallet.email : undefined}
                >
                  {(wallet.wallet_type === 1 && wallet.email) || "—"}
                </div>
                <div className="row-wallet-col row-wallet-col-balance">
                  {formatMoney(
                    (wallet.wallet_type === 1 ? wallet.wallet_balance : wallet.current_balance) / 100
                  )}
                </div>
                <div className="row-wallet-information-refund">
                  <Button
                    variant="contained"
                    size="small"
                    style={{
                      fontSize: "10px",
                      backgroundColor: "#01A532",
                      fontFamily: "Catamaran-Light",
                      cursor: 'pointer',
                      userSelect: 'none'
                    }}
                    onClick={(e) => {
                      setRechage(true);
                      setSelectedWallet(wallet);
                    }}
                  >
                    Recargar
                  </Button>
                </div>
              </div>
            ))}
            {/* pagination for wallets */}
            <div>
              <Pagination
                count={numPages} 
                color="primary"
                page={currentPage}
                onChange={handlePageChange}
                className="pagination"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WalletDetails;
